import * as React from 'react';
import { MastheadPortalId } from '../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { CollectPaymentConfirmation } from '../../components/tools/CollectPaymentConfirmation';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

export const AdminCollectPaymentConfirmationPage: React.FC = () => {
	const pathComponentNameProvider = React.useCallback((pathComponent: string) => {
		if (pathComponent === 'collect-payment') {
			return 'Collect Payment';
		}
		if (pathComponent === 'confirmation') {
			return 'Confirmation';
		}
		return undefined;
	}, []);

	return (
		<AdminDashboardPageLayout>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar pathComponentNameProvider={pathComponentNameProvider} />
			</Portal>
			<CollectPaymentConfirmation />
		</AdminDashboardPageLayout>
	);
};
